(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('appRegulations', {
            parent: 'site',
            url: '/regulations',
            data: {
            	authorities: [],
                pageTitle: 'Regulamin - VB Leasing'
            },
            views: {
            	'index@': {
                    templateUrl: 'app/views/regulations/regulations.html'
                }
            }
        });
    }
})();
